import { type SaveOperationRequest, SaveRequestToJSON } from "sequenceAnalyser/api/sequenceAnalyserApiClient";

import { getCredentialsHeaders } from "./credentials.ts";
import { urls } from "./urls.ts";

export async function getSequencesForDownload(requestParameters: SaveOperationRequest): Promise<string> {
  const url = `${urls.api}/sequenceAnalyzer/session/{seqAnalSessionId}/report`.replace(
    `{${"seqAnalSessionId"}}`,
    encodeURIComponent(String(requestParameters.seqAnalSessionId)),
  );

  const response = await fetch(url, {
    headers: {
      ...getCredentialsHeaders(),
      "Content-Type": "application/json",
    },
    method: "POST",
    cache: "no-cache",

    body: JSON.stringify(SaveRequestToJSON(requestParameters.saveRequest)),
  });

  if (!response.ok) {
    // handled in caller
    throw new Error(response.status === 404 ? "Not found" : await response.text());
  }

  return await response.text();
}

/**
 * Calls the endpoint to create a sequence analyzer session
 * @param selectedIds GES IDs
 * @param innerEntityType FeatureType
 *
 * Note: Temporarily copied from application!
 *
 */
export const createSequenceAnalyzerSession = async (selectedIds?: number[], innerEntityType?: string) => {
  const response = await fetch(`${urls.api}/sequenceAnalyzer/createSession`, {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json", ...getCredentialsHeaders() },
    body: JSON.stringify({
      sequenceIds: selectedIds,
      featureType: innerEntityType,
    }),
    cache: "no-cache",
  });

  if (!response.ok) {
    throw new Error(response.status === 404 ? "Not found" : await response.text());
  } else {
    const data = await response.text();
    if (data) {
      return data;
    }
  }

  return null;
};
